<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <v-container>
        <h2>About</h2>
        <v-card class="pa-4 mt-3">
            <v-card-text class="text-justify">
                <h2 class="mb-2">Locinder</h2>
                <p class="mb-3">
                    Locinder started with a simple question: <em>Why is it still hard to decide where to eat or what to try
                    next in our own city?</em> Every day, people search for food that satisfies their cravings while many
                    amazing local businesses remain undiscovered. Locinder was created to bridge that gap — helping
                    people discover not just places, but experiences, flavors, and moments worth sharing.
                    Locinder makes discovering local favorites feel effortless and exciting.
                </p>
                <p>
                    More than just an app, Locinder is a platform built for communities. We believe local businesses are
                    the heart of every city, and they deserve to be seen, supported, and celebrated. By connecting
                    customers with nearby food spots and trusted establishments, Locinder helps small businesses grow
                    while bringing people closer to the places that make their community special. Because sometimes, the
                    best memories begin with a simple search for something good to eat.
                </p>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>

export default {
    // eslint-disable-next-line vue/multi-word-component-names
    name: 'AboutPage',
};
</script>

<style scoped>
.v-container {
    width: 100vw;
    height: 100vh;
}
</style>